import { useAuthStore } from '@/common/stores/authStore';
import NoticeIcon from '@mui/icons-material/Logout';
import {
  Box,
  Button,
  ListItemText,
  Modal,
  styled,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { useRouter } from 'next/router';
import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'next-i18next';

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

interface LogoutModalProps {
  handleClose(): void;
  isLogOutOpen: boolean;
  setIsLogoutOpen: Dispatch<SetStateAction<boolean>>;
}

const LogoutModal: FC<LogoutModalProps> = ({
  handleClose,
  isLogOutOpen,
  setIsLogoutOpen
}) => {
  const { t } = useTranslation();
  const { signOut } = useAuthStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const router = useRouter();

  const handleOnCancelLogout = (event): void => {
    event.preventDefault();
    setIsLogoutOpen(false);
  };

  const handleLogout = async (event): Promise<void> => {
    event.preventDefault();
    await signOut();

    setTimeout(async () => {
      handleClose();
      await router.push('/');
    }, 500);
  };

  return (
    <>
      <Modal
        disableScrollLock
        onClose={handleOnCancelLogout}
        open={isLogOutOpen}
        sx={{
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        aria-labelledby="centered-modal"
        aria-describedby="centered-modal-description"
      >
        <MenuUserBox
          sx={{
            py: 3,
            px: 2,
            backgroundColor: theme.colors.alpha.white[100],
            borderRadius: 1,
            width: isMobile ? 260 : 310
          }}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap={1}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            sx={{ pt: 2 }}
            gap={1}
          >
            <NoticeIcon />
            <ListItemText primary={t('Are you sure you want to sign out?')} />
          </Box>

          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            px={0.5}
            pt={2}
            gap={0.2}
          >
            <Button
              sx={{ display: 'flex', flex: 1 / 2 }}
              color="error"
              onClick={handleLogout}
              size={isMobile ? 'small' : 'medium'}
            >
              {t('Sign out')}
            </Button>
          </Box>
        </MenuUserBox>
      </Modal>
    </>
  );
};

export default LogoutModal;
